import type { EventData, Mark } from './types'

async function req<T>(url: string, init?: RequestInit): Promise<T> {
  const res = await fetch(url, {
    ...init,
    headers: { 'Content-Type': 'application/json', ...(init?.headers ?? {}) },
  })
  if (!res.ok) {
    const body = await res.json().catch(() => ({}))
    throw new Error((body as { error?: string }).error ?? `request failed: ${res.status}`)
  }
  return res.json() as Promise<T>
}

export function createEvent(input: {
  title: string
  description: string
  candidates: { label: string; date?: string | null }[]
}): Promise<{ id: string }> {
  return req('/api/events', { method: 'POST', body: JSON.stringify(input) })
}

export function getEvent(id: string): Promise<EventData> {
  return req(`/api/events/${id}`)
}

// candidateId -> participantId -> 確度情報
export type BookingMap = Record<
  string,
  Record<string, { confidence: number; overlapCount: number; concern: number; leadingness: number }>
>

export function getBookings(id: string): Promise<BookingMap> {
  return req(`/api/events/${id}/bookings`)
}

export function importChouseisan(url: string): Promise<{ id: string }> {
  return req('/api/import', { method: 'POST', body: JSON.stringify({ url }) })
}

export function updateEvent(
  id: string,
  input: {
    title?: string
    description?: string
    candidates?: { id?: string; label: string; date?: string | null }[]
  }
): Promise<{ ok: true }> {
  return req(`/api/events/${id}`, { method: 'PATCH', body: JSON.stringify(input) })
}

export function deleteEvent(id: string): Promise<{ ok: true }> {
  return req(`/api/events/${id}`, { method: 'DELETE' })
}

export function addParticipant(
  eventId: string,
  input: { name: string; comment: string; cookie_id: string; marks: Record<string, Mark> }
): Promise<{ id: string }> {
  return req(`/api/events/${eventId}/participants`, {
    method: 'POST',
    body: JSON.stringify(input),
  })
}

export function updateParticipant(
  pid: string,
  input: { name?: string; comment?: string; cookie_id?: string; marks?: Record<string, Mark> }
): Promise<{ ok: true }> {
  return req(`/api/participants/${pid}`, { method: 'PATCH', body: JSON.stringify(input) })
}

export function deleteParticipant(pid: string): Promise<{ ok: true }> {
  return req(`/api/participants/${pid}`, { method: 'DELETE' })
}
